/* Global Theme Scripts */
document.addEventListener('DOMContentLoaded', function() {

  // Mobile menu toggle & outside-click close
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const siteNav = document.getElementById('SiteNav');
  const navBackdrop = document.querySelector('[data-menu-backdrop]');

  function closeMobileNav() {
    if (!siteNav) return;
    siteNav.classList.remove('is-open');
    if (menuToggle) {
      menuToggle.classList.remove('is-active');
      menuToggle.setAttribute('aria-expanded', 'false');
    }
    if (navBackdrop) {
      navBackdrop.classList.remove('is-open');
      navBackdrop.setAttribute('aria-hidden', 'true');
    }
  }

  function openMobileNav() {
    if (!siteNav) return;
    siteNav.classList.add('is-open');
    if (menuToggle) {
      menuToggle.classList.add('is-active');
      menuToggle.setAttribute('aria-expanded', 'true');
    }
    if (navBackdrop) {
      navBackdrop.classList.add('is-open');
      navBackdrop.setAttribute('aria-hidden', 'false');
    }
  }

  if (menuToggle && siteNav) {
    menuToggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = siteNav.classList.contains('is-open');
      if (isOpen) {
        closeMobileNav();
      } else {
        openMobileNav();
      }
    });

    // Close when clicking/tapping the empty region backdrop
    if (navBackdrop) {
      navBackdrop.addEventListener('click', function (e) {
        e.preventDefault();
        closeMobileNav();
      });
      navBackdrop.addEventListener('touchend', function (e) {
        e.preventDefault();
        closeMobileNav();
      }, { passive: false });
    }

    // Close when clicking outside of the navigation menu and toggle button
    document.addEventListener('click', function (event) {
      if (siteNav.classList.contains('is-open')) {
        const isClickInsideNav = siteNav.contains(event.target);
        const isClickOnToggle = menuToggle.contains(event.target);
        if (!isClickInsideNav && !isClickOnToggle) {
          closeMobileNav();
        }
      }
    });

    // Close on Escape key press
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && siteNav.classList.contains('is-open')) {
        closeMobileNav();
      }
    });

    // Close when resized to desktop viewport
    window.addEventListener('resize', function () {
      if (window.innerWidth > 767 && siteNav.classList.contains('is-open')) {
        closeMobileNav();
      }
    });
  }

  // Mobile Sub-menu Accordion Toggle (+ / -)
  const toggleBtns = document.querySelectorAll('.site-nav__toggle-btn');
  toggleBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const parentLi = btn.closest('li');
      if (parentLi) {
        const isExpanded = parentLi.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        const icon = btn.querySelector('.toggle-icon');
        if (icon) {
          icon.textContent = isExpanded ? '−' : '+';
        }
      }
    });
  });

  // Asynchronously load Product Recommendations
  const recommendationsSection = document.querySelector('.product-recommendations');
  
  if (recommendationsSection) {
    const url = recommendationsSection.dataset.url;
    
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        
        if (recommendations && recommendations.innerHTML.trim().length) {
          recommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error('Error loading recommendations:', e);
      });
  }
});